
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"36","viewBox":"0 0 100 62","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"100","height":"61.832","rx":"4","fill":"#ECC3FF"}}),_c('rect',{attrs:{"x":"67.939","y":"16.794","width":"23.664","height":"4.58","rx":"2.29","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"67.939","y":"25.191","width":"23.664","height":"3.817","rx":"1.908","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"67.939","y":"33.588","width":"23.664","height":"3.817","rx":"1.908","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"67.939","y":"41.221","width":"23.664","height":"4.58","rx":"2.29","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"67.939","y":"49.618","width":"23.664","height":"3.817","rx":"1.908","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"8.396","y":"15.267","width":"54.962","height":"38.168","rx":"4","fill":"#7B01B5"}}),_c('rect',{attrs:{"x":"8.131","y":"5.695","width":"39.024","height":"4.068","rx":"2.034","fill":"#B758E5"}}),_c('path',{attrs:{"d":"M41.218 33.913a.5.5 0 010 .866l-7.647 4.418a.5.5 0 01-.75-.433v-8.836a.5.5 0 01.75-.433l7.647 4.418z","fill":"#fff"}})])
          )
        }
      }
    